/**
 *  第三方库
 *  · 需标明用途，以及文档地址
 */
import Vue from 'vue'
import router from "@/router";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { DataTables, DataTablesServer } from 'vue-data-tables'
import uploader from 'vue-simple-uploader'
import barrage from 'vue2-barrage'
import VueClipboard from 'vue-clipboard2'
import BaiduMap from 'vue-baidu-map'


// 是否为线上环境
const IS_CLOUD = process.env.VUE_APP_MODE === 'cloud'

// [图片预览] https://github.com/mirari/v-viewer
Vue.use(Viewer);

// [table 组件] https://njleonzhang.github.io/vue-data-tables/#/?id=vue-data-tables
Vue.use(DataTables);
Vue.use(DataTablesServer);

// [文件上传] https://github.com/simple-uploader/vue-uploader
Vue.use(uploader);

// [弹幕]
Vue.use(barrage)

// VueAwesomeSwiper通过cdn引入了
window.VueAwesomeSwiper && Vue.use(window.VueAwesomeSwiper)

// [复制到粘贴板插件]
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// [百度地图]
Vue.use(BaiduMap,{
    ak:'PKXedYGlwF7kEh7ihfWTIsUHSSNfPl9X'
});

// [百度统计]
if (IS_CLOUD) {
    router.beforeEach((to, from, next) => {
        var _hmt = window._hmt || [];
        (function () {
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?36821d78221c3d917f48a439f723a8ed";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();
        if (to.path) {
            _hmt.push(['_trackPageview', to.fullPath]);
        }

        next();
    });
}
